export default "__VITE_ASSET__44ohB_Ux__"